import React from 'react'
import { observer } from 'mobx-react'
import { BetterComponent } from '../better-component/better-component'
import { Tooltip } from 'antd'
import { cleanNumericDisplays } from '../../_utils/utils'
import numeral from 'numeral'
import { numberWithPercent } from '../../_utils/numeral'

interface IProps {
    clicks: number
    ctrDecimal?: number
    status?: string
    expanded?: boolean
}

interface IState {}

@observer
export class ClicksColumnView extends BetterComponent<IProps, IState> {
    public render() {
        const clicksValue = this.renderClicks(this.props.clicks)
        const clicksExpanded = this.renderClicks(this.props.clicks, '0,0')

        let ctrValue: any = null
        if (this.props.ctrDecimal !== undefined) {
            ctrValue = (
                <span className="ctr-value">
                    {!this.props.clicks ? '--' : numberWithPercent(this.props.ctrDecimal)}
                </span>
            )
        }

        // The CTR sub-value is a sibling of the tooltip rather than a second child
        // inside it: the tooltip attaches its handlers to a single cloned child, so
        // the click target has to be the click count on its own.
        return (
            <div className="clicks-col-view">
                {this.props.expanded || clicksValue === clicksExpanded ? (
                    <span className="clicks-value">{clicksExpanded}</span>
                ) : (
                    <Tooltip trigger={'click'} title={clicksExpanded}>
                        <span className="clicks-value cursor-pointer">{clicksValue}</span>
                    </Tooltip>
                )}
                {ctrValue}
            </div>
        )
    }

    private renderClicks(clicks: number, format: string = '0.00a'): string {
        const value =
            clicks === undefined
                ? '--'
                : String(clicks).length > 4
                ? numeral(clicks).format(format)
                : numeral(clicks).format('0,0')

        return cleanNumericDisplays(value)
    }
}
